$( window ).on( "load", function() {
  $(".product-single__media").append(`<div id="custom-text-data"><span></span></div>`);
  $(".product-single__media").append(`<div id="custom-image-data-small"></div><div id="custom-image-data-medium"></div><div id="custom-image-data-large"></div><div id="custom-image-data-full"></div>`);
  $(".gpo-checkbox label a").attr("href","https://corecolour.com.au/pages/customization-terms-conditions");
  $(".gpo-checkbox label a").attr("target","_blank");
  $(".gpo-checkbox label a").attr("style","color:blue; text-decoration: underline;")
  // 切换文字
  $('.case-workshop-custom-text input').on("input",function(){
    $("#custom-text-data").text($(this).val());
    let count = ($(this).val().match(/w/gi) || []).length;
    var len = $(this).val().length
    if($(window).width() > 767) {
      var size = (9-len)*10
      if(count>=6){
        $("#custom-text-data").css("font-size", (size<=22 ? 22:size) + "px");
      } else {
        $("#custom-text-data").css("font-size", (size<30? 30: size) + "px");
      }

    } else {
      if(count>=4) {
        var size = (9-len)
        if(count>=6){
          $("#custom-text-data").css("font-size", (size<=3 ? 3:size) + "vw");
        } else {
          
          $("#custom-text-data").css("font-size", (size<=4 ? 4:size) + "vw");
        }
      } else  {
        var size = (9-len)+2
        $("#custom-text-data").css("font-size", (size<=5 ? 5:size) + "vw");
      }
    }
  });
  // 切换颜色
  $(".gpo-swatch__inner .top-color").on("click", function(){
    var colour = $(this).css("background-color");
    if (colour != "rgb(0, 0, 0)") {
      $("#custom-text-data").css("color", colour);
      $("#custom-text-data").css("text-shadow", "rgb(0, 0, 0) 2px 0px");
    } else {
      $("#custom-text-data").css("text-shadow", "rgb(255, 255, 255) 4px 0px");
      $("#custom-text-data").css("color", colour);
    };
  });

    $(".swatch__button--circle").on( "click", function() {
      $('.gpo-swatches input').prop('checked', false);
      $('.gpo-selected-values.has-value').empty();
      setInterval(function() {
        $("#custom-text-data").text($(".case-workshop-custom-text input").val());
      }, 100);
    });
    // 旋转文字
  $(".gpo-swatch__inner .gpo-swatch__image").on("click", function(){
     
    switch($(this).attr('id')) {
      case "image-swatches-2_1_1700024705838":
        var current_colour = $("#custom-text-data").css("color");
        $("#custom-text-data").css("color", current_colour);
        $("#custom-text-data").css("text-shadow", "#000 4px 0px");
        $("#custom-text-data").css("text-transform", "lowercase");
        $("#custom-text-data").css("font-style", "unset");
        $(".gpo-swatch__inner .top-color").on("click", function(){
          var colour = $(this).css("background-color");
          if (colour != "rgb(0, 0, 0)") {
            $("#custom-text-data").css("color", colour);
            $("#custom-text-data").css("text-shadow", "rgb(0, 0, 0) 2px 0px");
          } else {
            $("#custom-text-data").css("text-shadow", "rgb(255, 255, 255) 4px 0px");
            $("#custom-text-data").css("color", colour);
          };
        });
        break;
      case "image-swatches-2_2_1700025496996":
        var current_colour = $("#custom-text-data").css("color");
        $("#custom-text-data").css("color", current_colour);
        $("#custom-text-data").css("text-shadow", "#000 4px 0px");
        $("#custom-text-data").css("text-transform", "uppercase");
        $("#custom-text-data").css("font-style", "unset");
        $(".gpo-swatch__inner .top-color").on("click", function(){
          var colour = $(this).css("background-color");
          if (colour != "rgb(0, 0, 0)") {
            $("#custom-text-data").css("color", colour);
            $("#custom-text-data").css("text-shadow", "rgb(0, 0, 0) 2px 0px");
          } else {
            $("#custom-text-data").css("text-shadow", "rgb(255, 255, 255) 4px 0px");
            $("#custom-text-data").css("color", colour);
          };
        });
        break;
      case "image-swatches-2_3_1700025497804":
        $("#custom-text-data").css("color", current_colour);
        $("#custom-text-data").css("text-shadow", "#000 4px 0px");
        $("#custom-text-data").css("text-transform", "none");
        $("#custom-text-data").css("font-style", "italic");
        $(".gpo-swatch__inner .top-color").on("click", function(){
          var colour = $(this).css("background-color");
          if (colour != "rgb(0, 0, 0)") {
            $("#custom-text-data").css("color", colour);
            $("#custom-text-data").css("text-shadow", "rgb(0, 0, 0) 2px 0px");
          } else {
            $("#custom-text-data").css("text-shadow", "rgb(255, 255, 255) 4px 0px");
            $("#custom-text-data").css("color", colour);
          };
        });
        break;
      case "image-swatches-2_4_1700025507761":
        var current_colour = $("#custom-text-data").css("color");
        $("#custom-text-data").css("color", "white");
        $("#custom-text-data").css("text-transform", "none");
        $("#custom-text-data").css("font-style", "unset");
        $(".gpo-swatch__inner .top-color").on("click", function(){
          var outline_colour = $("#custom-text-data").css("color") + " 4px 0px";
          if (outline_colour != "rgb(255, 255, 255) 4px 0px") {
            $("#custom-text-data").css("text-shadow", outline_colour);
            $("#custom-text-data").css("color", "white");
          } else {
            $("#custom-text-data").css("text-shadow", outline_colour);
            $("#custom-text-data").css("color", "black");
          };
        });
        break;
      case "image-swatches-1_1_1700024705838":
        $("#custom-text-data").css("align-items", "flex-start");
        $("#custom-text-data").css("transform", "none");
        if($(window).width() > 1440) {
          $("#custom-text-data").css("font-size", "50px");
        } else if($(window).width() > 767) {
          $("#custom-text-data").css("font-size", "3.5vw");
        } else {
          $("#custom-text-data").css("font-size", "7vw");
        };
        $("#custom-text-data").css("width", "34.5%");
        $("#custom-text-data").css("height", "50%");
        $("#custom-text-data").css("top", "36%");
        $("#custom-text-data").css("left", "33%");
        $("#custom-text-data").css("padding-top", "0");
        break;
      case "image-swatches-1_2_1700025496996":
        $("#custom-text-data").css("align-items", "center");
        $("#custom-text-data").css("transform", "none");
        if($(window).width() > 1440) {
          $("#custom-text-data").css("font-size", "50px");
        } else if($(window).width() > 767) {
          $("#custom-text-data").css("font-size", "3.5vw");
        } else {
          $("#custom-text-data").css("font-size", "7vw");
        };
        $("#custom-text-data").css("width", "34.5%");
        $("#custom-text-data").css("height", "50%");
        $("#custom-text-data").css("top", "36%");
        $("#custom-text-data").css("left", "33%");
        $("#custom-text-data").css("padding-top", "0");
        break;
      case "image-swatches-1_3_1700025497804":
        $("#custom-text-data").css("align-items", "flex-end");
        $("#custom-text-data").css("transform", "none");
        if($(window).width() > 1440) {
          $("#custom-text-data").css("font-size", "50px");
        } else if($(window).width() > 767) {
          $("#custom-text-data").css("font-size", "3.5vw");
        } else {
          $("#custom-text-data").css("font-size", "7vw");
        };
        $("#custom-text-data").css("width", "34.5%");
        $("#custom-text-data").css("height", "50%");
        $("#custom-text-data").css("top", "36%");
        $("#custom-text-data").css("left", "33%");
        $("#custom-text-data").css("padding-top", "0");
        break;
      case "image-swatches-1_4_1700025507761":
        $("#custom-text-data").css("align-items", "flex-end");
        $("#custom-text-data").css("transform", "rotate(90deg)");
        if($(window).width() > 1440) {
          $("#custom-text-data").css("font-size", "75px");
        } else if($(window).width() > 767) {
          $("#custom-text-data").css("font-size", "5vw");
        } else {
          $("#custom-text-data").css("font-size", "10.5vw");
        };
        $("#custom-text-data").css("width", "50%");
        $("#custom-text-data").css("height", "34.5%");
        $("#custom-text-data").css("top", "44%");
        $("#custom-text-data").css("left", "25%");
        $("#custom-text-data").css("padding-top", "0");
        break;
      case "image-swatches-1_5_1700025507132":
        $("#custom-text-data").css("align-items", "center");
        $("#custom-text-data").css("transform", "rotate(90deg)");
        if($(window).width() > 1440) {
          $("#custom-text-data").css("font-size", "75px");
        } else if($(window).width() > 767) {
          $("#custom-text-data").css("font-size", "5vw");
        } else {
          $("#custom-text-data").css("font-size", "10.5vw");
        };
        $("#custom-text-data").css("width", "50%");
        $("#custom-text-data").css("height", "34.5%");
        $("#custom-text-data").css("top", "44%");
        $("#custom-text-data").css("left", "25%");
        $("#custom-text-data").css("padding-top", "0");
        break;
      case "image-swatches-1_6_1700025506615":
        $("#custom-text-data").css("align-items", "flex-start");
        $("#custom-text-data").css("transform", "rotate(90deg)");
        if($(window).width() > 1440) {
          $("#custom-text-data").css("font-size", "75px");
        } else if($(window).width() > 767) {
          $("#custom-text-data").css("font-size", "5vw");
        } else {
          $("#custom-text-data").css("font-size", "10.5vw");
        };
        $("#custom-text-data").css("width", "50%");
        $("#custom-text-data").css("height", "34.5%");
        $("#custom-text-data").css("top", "44%");
        $("#custom-text-data").css("left", "25%");
        $("#custom-text-data").css("padding-top", "0");
        break;
      case "image-swatches-1_7_1701658656324":
        $("#custom-text-data").css("align-items", "flex-start");
        $("#custom-text-data").css("transform", "none");
        if($(window).width() > 1440) {
          $("#custom-text-data").css("font-size", "50px");
        } else if($(window).width() > 767) {
          $("#custom-text-data").css("font-size", "3.5vw");
        } else {
          $("#custom-text-data").css("font-size", "7vw");
        };
        $("#custom-text-data").css("width", "34.5%");
        $("#custom-text-data").css("height", "50%");
        $("#custom-text-data").css("top", "36%");
        $("#custom-text-data").css("left", "33%");
        $("#custom-text-data").css("padding-top", "8%");
        break;
    }
    $("#custom-text-data").text($('.case-workshop-custom-text input').val());
    let count = ($('.case-workshop-custom-text input').val().match(/w/gi) || []).length;
    var len = $('.case-workshop-custom-text input').val().length
    if($(window).width() > 767) {
      var size = (9-len)*10
      if(count>=6){
        $("#custom-text-data").css("font-size", (size<=22 ? 22:size) + "px");
      } else {
        $("#custom-text-data").css("font-size", (size<30? 30: size) + "px");
      }
    } else {
      if(count>=4) {
        var size = (9-len)
        if(count>=6){
          $("#custom-text-data").css("font-size", (size<=3 ? 3:size) + "vw");
        } else {
          
          $("#custom-text-data").css("font-size", (size<=4 ? 4:size) + "vw");
        }
      } else  {
        var size = (9-len)+2
        $("#custom-text-data").css("font-size", (size<=5 ? 5:size) + "vw");
      }
    }

  });

  $(".image-size input").on("click", function(){
    var image_url = $(".gpo-fpreview a").attr("href");
    $("#custom-image-data-small img").remove();
    $("#custom-image-data-medium img").remove();
    $("#custom-image-data-large img").remove();
    $("#custom-image-data-full img").remove();
    switch($(this).attr('id')) {
      case "image-swatches-4_1":
        $("#custom-image-data-small").append('<img src=' + image_url + ' />');
        break;
      case "image-swatches-4_2":
        $("#custom-image-data-medium").append('<img src=' + image_url + ' />');
        break;
      case "image-swatches-4_3":
        $("#custom-image-data-large").append('<img src=' + image_url + ' />');
        break;
      case "image-swatches-4_4":
        $("#custom-image-data-full").append('<img src=' + image_url + ' />');
        break;
    };

    $(".gpo-fileRemove").on("click", function(){
      $("#custom-image-data-small img").remove();
      $("#custom-image-data-medium img").remove();
      $("#custom-image-data-large img").remove();
      $("#custom-image-data-full img").remove();
    });
  });
  
});